import React, { useState, useEffect } from 'react';
function SmallSlideShow(albumId) {
    const [photos, setPhotos] = useState([]);
    const [currIndex, setCurrIndex] = useState(0);
    useEffect(
        () => {
            var url = "/Photo/GetPhotos?photoAlbumId=" + albumId.albumId;
            console.log(url);
            console.log(albumId);
            fetch(url).then(res => res.json()).then((data) => {
                console.log(data);
                setPhotos(data);
                console.log(data);
            }).catch(err => alert(err));
        }, [albumId]);
    useEffect(() => {

        //Implementing the setInterval method
        const interval = setInterval(() => {
            if (currIndex < (photos.length - 1)) {
                setCurrIndex(currIndex + 1);
                console.log(" added " );
            } else {
                setCurrIndex(0);
                console.log("Zeroed");
            }



        }, 3000);

        //Clearing the interval
        return () => clearInterval(interval);
    }, [currIndex,photos]);

    return (<>
        {photos.length > 0 && <img alt="slideShow" className="small-image rounded" src={photos[currIndex].photoUrl}></img>} </>)
    

}
export default SmallSlideShow

